<template>
  <iframe :src="converted()" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen v-if="convertYoutube"></iframe>
  <iframe v-else :src="video" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
</template>
<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    data() {
    return {
    };
  },
  props: ['convertYoutube'],
  methods: {
    converted() {
      const string = this.modalData.video;
      const exp = /\s*[a-zA-Z\/\/:\.]*youtu(be.com\/watch\?v=|.be\/)([a-zA-Z0-9\-_]+)([a-zA-Z0-9\/\*\-\_\?\&\;\%\=\.]*)/i;
      const matches = exp.exec(string);
      if (matches) {
        return `//www.youtube.com/embed/${matches[2]}?enablejsapi=1`;
      }
    }
  },
  computed: {
    ...mapGetters({
      getData: 'modal/getData',
      modalData: 'modal/getData'
    }),

    video: function() {
      if(this.getData && this.getData.video) {
        return this.getData.video;
      }
    }
  },
};

</script>


// WEBPACK FOOTER //
// resources/components/apps/video-modal.vue